import { useEffect, useRef } from 'react';
import { useChatSidebarStore } from '@ui/features/mildang-ai/stores/chatStore';
import notification from '@shared/utils/notification';

// Notification 클릭 후 진입 처리 hooks
export const useNotificationClick = () => {
  const { initState } = useChatSidebarStore();

  const unsubscribeRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    let active = true;

    (async () => {
      const unsubscribe = notification.onNotificationClick((data) => {
        if (data.channelId) {
          initState(true, data.channelId, 'CHANNEL');
        }
      });
      if (active) {
        unsubscribeRef.current = unsubscribe;
      } else {
        unsubscribe();
      }
    })();

    return () => {
      active = false;
      unsubscribeRef.current?.();
      unsubscribeRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const NotificationClick = () => {
  useNotificationClick();
  return null;
};
